<template>
  <div class="game_packs_banner d-flex-column align-start t-white pad-24-0">
    <div class="game_packs_banner d-flex-column align-start t-white pad-24-0">
      <h1 class="t-white font-family-1 f-w-600 title-h2">
        {{ getGamePack.title }}
      </h1>
      <p class="regular-l t-light font-family-2 md-hide">
        {{ description }}
      </p>
      <div
        class="d-flex-row justify-start main_row hide_scroll mt-20"
        style="position: relative"
        :style="{ overflow: overflow, left: `-${left}px` }"
        v-dragscroll.x
        v-on:dragscrollstart="onDrag('auto')"
        v-on:dragscrollend="onDrag('visible')"
        ref="scrollContainer"
        v-if="showChips"
      >
        <tooltip
          v-for="feature in features"
          :key="feature"
          :text="feature.description"
          :position="'top'"
        >
          <chip :text="feature.title" :icon="feature.icon" />
        </tooltip>
      </div>
    </div>
  </div>
</template>
<script setup>
import LockIcon from "../icons/LockIcon.vue";
import VpnIcon from "../icons/VpnIcon.vue";
import ShieldIcon from "../icons/ShieldIcon.vue";
import SupportIcon from "../icons/SupportIcon.vue";
import RefundIcon from "../icons/RefundIcon.vue";
import CashbackIcon from "../icons/CashbackIcon.vue";
import Chip from "../custom/Chip.vue";
import Tooltip from "../custom/Tooltip.vue";
import { computed, ref } from "vue";
const { t } = useI18n();
const { getGamePack } = useGameStore();

const features = computed(() => {
  return [
    {
      icon: LockIcon,
      title: t("boosting-features.ssl-secure"),
      description: t("boosting-features.ssl-secure-description"),
    },
    {
      icon: VpnIcon,
      title: t("boosting-features.vpn"),
      description: t("boosting-features.vpn-description"),
    },
    {
      icon: ShieldIcon,
      title: t("boosting-features.save-service"),
      description: t("boosting-features.save-service-description"),
    },
    {
      icon: SupportIcon,
      title: t("boosting-features.support"),
      description: t("boosting-features.support-description"),
    },
    {
      icon: RefundIcon,
      title: t("boosting-features.money-refund"),
      description: t("boosting-features.money-refund-description"),
    },
    {
      icon: CashbackIcon,
      title: t("boosting-features.cashback"),
      description: t("boosting-features.cashback-description"),
    },
  ];
});

const overflow = ref("visible");
const left = ref(0);
const scrollContainer = ref(null);

const props = defineProps({
  packTitle: {
    type: String,
    default: "",
  },
  packDescription: {
    type: String,
    default: "",
  },
  showChips: {
    default: true,
  },
});

const description = computed(() => {
  // if (["ow-galactic-guns-boost"].includes(getGamePack?.slug)) {
  //   return getGamePack?.description;
  // }
  return getGamePack?.page_description;
});

const onDrag = (type) => {
  const container = scrollContainer.value; // Select the container

  if (type === "visible") {
    const scrollX = container.scrollLeft; // Capture the horizontal scroll position
    overflow.value = "visible"; // Set overflowX to "visible"
    left.value = `${scrollX}`;
    // container. = scrollX; // Restore horizontal scroll position
  } else {
    left.value = 0;
    overflow.value = "auto"; // Restore overflow property
  }
};
</script>
